import script from "./ColorImageStrip.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorImageStrip.vue?vue&type=script&setup=true&lang=js"

import "./ColorImageStrip.vue?vue&type=style&index=0&id=61e4e77a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e4e77a"]])

export default __exports__